<div class="container">
  <div class="dialog-badge" aria-hidden="true">
    <span class="badge-icon">{{ resetCompleted ? '✓' : '•' }}</span>
    <span class="badge-label">{{ resetCompleted ? 'Próximo passo' : 'Recuperação de acesso' }}</span>
  </div>

  <h1 mat-dialog-title class="dialog-title">
    {{ resetCompleted ? 'Senha resetada' : 'Resetar Senha' }}
  </h1>

  <div class="dialog-content">
    @if (!resetCompleted) {
      <form [formGroup]="form">
        <div mat-dialog-content>
          <div class="message-card">
            <p class="dialog-text">
              Informe seu Código ANAC para reiniciar o acesso. Depois disso, faça login com Código ANAC e CPF para validar o e-mail e cadastrar uma nova senha.
            </p>
          </div>
          <input type="text" class="anac_code" placeholder="Código ANAC" formControlName="anacCode" required>
          @if (submited && form.invalid) {
            <app-error-form>
              Informe o Código ANAC.
            </app-error-form>
          }
        </div>
        <div mat-dialog-actions class="actions">
          <button class="btn btn-close" mat-dialog-close>Cancelar</button>
          <button class="btn btn-confirm" (click)="confirm()" [disabled]="form.invalid || loading">
            {{ loading ? 'Confirmando...' : 'Confirmar' }}
          </button>
        </div>
      </form>
    }

    @if (resetCompleted) {
      <div class="success-state" mat-dialog-content>
        <div class="success-mark" aria-hidden="true">✓</div>
        <div class="message-card success-card">
          <p class="success-text">
            A senha foi resetada com sucesso.
          </p>
          <p class="success-text">
            Agora faça login com seu Código ANAC e CPF.
          </p>
          <p class="success-text">
            Na próxima etapa, você validará seu e-mail para cadastrar uma nova senha.
          </p>
        </div>
        <div mat-dialog-actions class="actions success-actions">
          <button class="btn btn-primary" type="button" (click)="backToLogin()">
            Voltar ao login
          </button>
        </div>
      </div>
    }
  </div>
</div>
